import { Navigate } from 'react-router-dom';
import { useAuth } from '../../stores/auth-context';

export function RootRedirect() {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user) return <Navigate to="/login" replace />;

  if (user.role === 'monitoring') return <Navigate to="/monitoring" replace />;
  if (user.role === 'operator') return <Navigate to="/scan" replace />;

  return <Navigate to="/dashboard" replace />;
}
